export enum SupportedLanguage {
	EN = "en",
	NB = "nb",
	SV = "sv",
}

// Welcome-screen display order (Nordic-LSR); also the i18n supported-languages whitelist.
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
	SupportedLanguage.SV,
	SupportedLanguage.NB,
	SupportedLanguage.EN,
];
